const messages = {
    cookies: {
        message:{
            tableHead1: "Cookie",
            tableHead2: "Name",
            tableHead3: "Purpose",
            tableHead4: "Duration",
            tableRow1A: "Cookie preference",
            tableRow1B: "europarlcookiepolicysagreement",
            tableRow1C1: "This cookie is used to remember a user’s choice about cookies on ",
            tableRow1CLink: "epnewshub.eu",
            tableRow1CUrl: "https://www.epnewshub.eu/",
            tableRow1C2: ". Where users have previously indicated a preference, that user’s preference will be stored in this cookie.",
            tableRow1D: "6 months",
            tableRow2A: "At Internet",
            tableRow2B: "Atidvisitor",
            tableRow2C: "Used to monitor the performance of pages visited by users of Parliament's websites.",
            tableRow2D: "13 months",
            tableRow3A: "",
            tableRow3B: "Idrxvr",
            tableRow3C: "Used to monitor traffic and highlight issues that may arise by people browsing our websites.",
            tableRow3D: "13 months",
            tableRow4A: "",
            tableRow4B: "Atredir",
            tableRow4C: "Used to keep of information in case of a JS redirection.",
            tableRow4D: "13 months",
            tableRow5A: "",
            tableRow5B: "Atuserid",
            tableRow5C: "Used to store the visitor anonymous ID on the Parliament's websites.",
            tableRow5D: "13 months",
            tableRow6A: "",
            tableRow6B: "Atreman",
            tableRow6C: "Used to keep a prior attribution campaign in memory.",
            tableRow6D: "30 days",
            tableRow7A: "",
            tableRow7B: "atsession",
            tableRow7C: "Used to record the list of new campaigns encountered during a visit, in order to avoid measuring the same campaign several times.",
            tableRow7D: "30 minutes",
            cookiesWidgetAccepted: "Based on the information at our disposal, it seems you accepted our analytics cookies. If you change your mind, you may activate the following choice:",
            cookiesWidgetRefused: "Based on the information at our disposal, it seems you refused our analytics cookies. If you change your mind, you may activate the following choice:",
            cookiesWidgetNeither: "Based on the information at our disposal, it seems you neither accepted nor refused our analytics cookies. Consequently, we did not place any on your device. Could you please explicitly express your choice:",
            cookiesWidgetRadio1: "I refuse analytics cookies",
            cookiesWidgetRadio2: "I accept analytics cookies",
        },
    },
    newshub: {
        description: "EP Newshub is a real time news aggregator gathering all items published online by Members, political groups and news services from the European Parliament.",
        action: {
            advancedsearch: "Advanced Search",
            anchor: "Permalink",
            apply: "Apply",
            back: "Back",
            chooseFiles: "Choose files",
            clear: "Clear",
            clearAll: "Clear all",
            clearAllFilters: "Clear all filters",
            close: "Close",
            copied: "copied to clipboard",
            facebook: "Facebook",
            filter: "Filter",
            formSended: "Feedback message sent",
            goBack: "Back",
            email: "Email",
            embed: "Embed",
            instagram: "Instagram",
            next: "Next",
            prev: "Previous",
            done: "Done",
            refresh: "Refresh",
            rss: "RSS Feed",
            search: "Search",
            send: "Send",
            share: "Share",
            showNewContent: "Show new content",
            signal: "Signal",
            signalCopied: "Copied to clipboard; share this link on your Signal app",
            skipToContent: "Skip to main content",
            switchTheme: "Switch theme",
            telegram: "Telegram",
            toggleMenu: "Toggle menu",
            translateContent: "Translate content",
            hideTranslation: "Hide translation",
            twitter: "Twitter",
            bluesky: "Bluesky",
            // Shown only as links on a contributor's page; nothing collects their posts.
            linkedin: "LinkedIn",
            threads: "Threads",
            tiktok: "TikTok",
            website: "Website",
            youtube: "YouTube",
            viewAll: "View all",
            viewChannel: "View",
            viewPost: "View on %{network}",
            showMoreImage: "Show more",
            showLessImage: "Show less",
            whatsapp: "WhatsApp",
            www: "WWW",
            mainSearch: "Exact words or phrase",
            mainSearchPlaceholder: "Enter the exact words or phrase",
            includeWords: "ANY of these words",
            includeWordsPlaceholder: "Include ANY of these words in the search",
            withHashtags :"Search #hashtags",
            withHashtagsPlaceholder: "Search results containing these #hashtags",
            excludeWords: "Exclude words",
            excludeWordsPlaceholder: "Search results without these words",
            allWords: "All these words",
            mentions: "Search @mentions",
            mentionsPlaceholder: "Search results containing these @mentions",
            allWordsPlaceholder:"Search results with all these words",
            clearAllTimeLine: "Clear selection"
        },
        error:{
            error404:{
                title:"404",
                description1: "The page you’re trying to visit doesn’t exist or has changed",
                description2: "Please visit the ",
                link: "Homepage",
                description3: " to continue",
            },
            error503:{
                title:"503",
                description1: "Service unavailable",
                description2: "Please try again later",

            },
            notFoundContent:{
                title:"No results",
                description1: "There where no items matching your criteria.",
            },
            notFoundContentTips:{
                title:"Search tips",
                tip1: "Check your spelling",
                tip2: "Try searching by topic or channel",
                tip3: "Broaden your search by using few words or more general terms",
                tip4: "You can also make use of the ",
                link: "Timeline",
            },

            notFoundContentHome: {
                title:"Sorry, we couldn’t find any results for your search",
            },

            notFoundContentTipsHome:{
                title:"Here are a few search tips:",
                tip1: "Broaden your search by using fewer or less specific terms",
                tip2: "Check the keywords for spelling",
                tip3: "Alternatively, you can try out the ‘Advanced Search’ or use the ‘Trending topics’ and ‘Filters’ features. You can also browse content using the %{link1} or look-up contributors on the %{link2} page",
                link1: "Timeline",
                link2: "Channels"

            },

            notFoundContentTimeline: {
                title:"Sorry, we couldn’t find any results for your search",
            },

            notFoundContentTipsTimeline:{
                title:"Here are a few search tips:",
                tip1: "Expand the time/date range selected",
                tip2: "Broaden your search by using fewer or less specific terms",
                tip3: "Check the keywords for spelling ",
                tip4: "Alternatively, you can try out the ‘Advanced Search’ or use the ‘Trending topics’ and ‘Filters’ features.",
            },

            notFoundContentChannels: {
                title:"Sorry, we couldn’t find any channel with that name",
                description1: "Please check the keywords for spelling or filter channels using the top navigation bar.",
            },

        },
        bottomBar: {
            top: "Top",
            topics: "Topics",
            filters: "Filters",
        },
        channel: {
            country: "By country",
            politicalGroup: "By political group",
            president: "President",
        },
        filter: {
            channels: "MEP Channels",
            currentFilters: "Filters",
            institutions: "Institution Channels",
            mediaTypes: "Media Types",
            networks: "Networks",
        },
        institution: {
            committees: "Committees",
            eppress: "EP Accounts",
            otherInstitutions: "Other Institutions",
            grouppress: "Political Groups",
            meps: "MEPs"

        },
        mediaType: {
            photo: "Photos",
            text: "Text only",
            video: "Videos",
        },
        network: {
            bluesky: "Bluesky",
            instagram: "Instagram",
            twitter: "X (Twitter)",
        },
        menu: {
            channels: "Channels",
            help: "Help",
            home: "Home",
            timeline: "Timeline",
            darkmode: "Dark mode",
            lightmode: "Light mode",
            tutorial: "Tutorial",
            dataProtectionNotice: "Data Protection Notice",
            legalNote: "Cookies policy",
            sendFeedback: "Send feedback",
            claim:{
                title: "European Parliament's Newshub",
                description: "aggregates information from the Parliament's President, MEPs, political groups and news services in a single place. Elected every five years, Parliament is the EU's only directly-elected body.",
            },
        },
        pagination: {
            results: "Showing %{total} results",
            resultsOne: "Showing %{total} result"
        },
        search: {
            suggestedWords: "Suggested words",
            suggestedChannels: "Suggested channels",
            oldSearches:"Previous searches"
        },
    },
    social: {
        // social.action.* is gone: it said "Tweeted" on every card in a feed of tweets, and the
        // network is already named by the mark beside the time and by the "View on X" button.
        //
        // The name of the network as its own users write it, for the "View on ..." link. Twitter is
        // "X" to a reader, but `twitter` everywhere in the code and the API, so the two cannot be the
        // same string.
        network: {
            bluesky: "Bluesky",
            facebook: "Facebook",
            instagram: "Instagram",
            linkedin: "LinkedIn",
            rss: "RSS",
            threads: "Threads",
            tiktok: "TikTok",
            twitter: "X",
            website: "Website",
            youtube: "YouTube",
        },
        message: {
            postedBy: "Posted by %{firstName} %{lastName}",
            repostedFrom: "Reposted",
            // Shown in place of the political group and country. The President speaks for the
            // institution, so the group they were elected under is not the identity that matters on
            // a post from the presidency account.
            presidentTitle: "President of the European Parliament",
            inReplyTo: "In reply to",
            // Folded consecutive posts by one account. Written to read correctly at 1 as well as many,
            // so no plural form is needed: "1 more post from X", "4 more posts from X" would need
            // pluralisation this app has no precedent for.
            morePostsFrom: "%{count} more from %{name}",
            collapsePosts: "Show less from %{name}",
            // Used when no name is available at all - neither a contributor name nor an account one.
            morePosts: "%{count} more",
            collapsePostsPlain: "Show less",
            // Read as one line above the post: "Reposted @handle", or "Reposted" on the older items
            // stored before the ingest recorded who was reposted.
            repost: "Reposted",
            // The link line closing the box under a quote's words.
            viewQuotedPost: "View the quoted post on %{network}",
            // No box: a Bluesky quote, until the ingest keeps the embedded record.
            quote: "Quoted a post",
            // Used only for items stored before the ingest recorded who was replied to.
            reply: "In reply to a post",
        },
    },
    sendFeedback: {
        label: {
            name: "Name",
            lastName: "Last name",
            email: "Email",
            comments: "Comments",
        },
        placeholder: {
            name: "Enter name",
            lastName: "Enter last name",
            email: "Enter email",
            comments: "Briefly explain what the issue is or if something was not working as expected",
        },
        message: {
            acceptPolicy1: "I accept the ",
            acceptPolicy2: "Data Protection Notice",
        },
        snackbar: {
            message: "A message has been sent to our support team",
        },
        email: {
            notValid:"It must be a valid email "
        }
    },
    timeline: {
        filter: {
            lastDay: "24 hours",
            lastWeek: "7 days",
            lastMonth: "30 days",
        },
        tooltip: "The timeline allows you to select results for a specific period of time. The chart is displayed in a 24-hour, 7-day, 30-day format and the results can be narrowed using the selector. You can adjust the selection using the side arrows or you can move it left or right by dragging it. To return to the default view, use the ‘Clear all’ button."
    },
    topic: {
        message: {
            title: "Trending topics",
        },
    },
    tutorial: {
        homeTutorial: {
            title: {
                step0: "Welcome to the EP Newshub!",
                step1: "Get started with Filters",
                step2: "Advanced Search",
                step3: "Dynamic Timeline",
                step4: "Channels",
            },
            message: {
                step0: "The only platform that aggregates real time information from the Parliament President, MEPs, political groups and news services in a single place.\n" +
                    "Check out the latest results or use the intuitive search function to find the most relevant content and contributors.\n",
                step1: "Use the Filters to narrow down results for specific Channels, Countries or Media type.\n" +
                    "Combine multiple options for an even more accurate result.\n" +
                    "Once applied, they remain active throughout the session; simply hit \"Clear all\" to start over.\n",
                step2: "Every time you perform a search, the advanced module is enabled to allow you to fine-tune various parameters.\n" +
                    "To narrow-down the results, combine these options to include or exclude words, search #hashtags or @mentions and to set the date range (maximum 30 days backwards)\n",
                step3: "The Timeline offers a great perspective on the evolution of the results and gives you various options to select a specific range.\n" +
                    "Toggle between 24-hour/ 7-day/ 30-day pre-sets.\n" +
                    "Use the selector to narrow or expand the selection range as you wish by using the side arrows or by dragging left or right.\n",
                step4: "All EP Newshub contributors are now available in the dedicated Channels section.\n" +
                    "Browse through categories - President, MEPs, Political Groups, Committees and our News services - or use the search on top.\n" +
                    "Click on the View button to see details for each contributor and their recent activity.\n",
            },
        },
    },
};

export default messages;
